module.exports = __webpack_public_path__ + "img/Unified.ecb26f4a.svg";